<template>
  <div class="card" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="container">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="90px" status-icon>
        <el-form-item label="申请书编号">
          <el-input :value="form.origin_no" disabled></el-input>
        </el-form-item>
        <el-form-item label="隔热膜型号">
          <el-input :value="`${series.name}·${version.name}`" disabled></el-input>
        </el-form-item>
        <el-form-item label="施工店">
          <el-input :value="company.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="车主姓名" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="车主电话" prop="mobile">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="车型" prop="brand">
          <el-input v-model="form.brand"></el-input>
        </el-form-item>
        <el-form-item label="车牌号码" prop="license">
          <el-input v-model="form.license"></el-input>
        </el-form-item>
        <el-form-item label="施工日期" prop="worked_at">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.worked_at"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="装贴位置" prop="sites">
          <el-checkbox-group v-model="form.sites">
            <el-checkbox name="sites" :label="item.id" v-for="item in siteList" :key="item.id">
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="disabled" @click="onSubmit">提交</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getSiteList, getOrderDetail, addCard } from '@/api/index'
export default {
  name: 'Card',
  data() {
    return {
      uuid: '',
      form: {
        series_id: '',
        version_id: '',
        origin_no: '',
        company_id: '',
        username: '',
        mobile: '',
        brand: '',
        license: '',
        worked_at: '',
        sites: []
      },
      rules: {
        username: [{ required: true, message: '请输入车主姓名', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入车主电话', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        brand: [{ required: true, message: '请输入车型', trigger: 'blur' }],
        license: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              // 根据最新的车牌号规则，这里选择普通车正则表达式
              const plateReg =
                /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]$/
              if (!plateReg.test(value)) {
                callback(new Error('车牌号格式不正确'))
              } else {
                callback()
              }
            },
            trigger: ['blur']
          }
        ],
        worked_at: [{ required: true, message: '请选择施工日期', trigger: 'blur' }],
        sites: [{ type: 'array', required: true, message: '请选装贴位置', trigger: 'blur' }]
      },
      disabled: false,
      siteList: [],
      company: {},
      series: { name: '' },
      version: { name: '' },
      fullscreenLoading: true
    }
  },
  created() {
    const { origin_no } = this.$route.query
    if (!origin_no) {
      this.$message.error('无效的参数')
      return
    } else {
      this.origin_no = origin_no
      this.loadOrderData()
      this.loadSiteData()
    }
  },

  methods: {
    loadOrderData() {
      getOrderDetail({ origin_no: this.origin_no })
        .then((res) => {
          const { company, series, version } = res.data
          this.company = company
          this.series = series
          this.version = version
          this.form.series_id = series.id
          this.form.version_id = version.id
          this.form.origin_no = res.data.origin_no
          this.form.company_id = company.id
          this.fullscreenLoading = false
        })
        .catch((err) => {
          this.$message.error(err.msg || '申请书加载失败')
          this.fullscreenLoading = false
          this.disabled = true
        })
    },
    loadSiteData() {
      getSiteList()
        .then((res) => {
          this.siteList = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    reset() {
      this.$refs.form.resetFields()
    },
    onSubmit() {
      this.disabled = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          addCard({ ...this.form })
            .then((res) => {
              this.$message.success('提交成功')
              setTimeout(() => {
                this.$router.push('/warranty')
              }, 1000)
            })
            .catch((err) => {
              this.disabled = false
              this.$message.error(err.msg || '提交失败')
            })
        } else {
          this.disabled = false
          this.$message.error('请填写完整')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  justify-content: center;
  .container {
    padding: 20px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}
</style>
